import axios from "axios";
import {CreatedCustomer, Customer} from "./customersSlice";

const createHeaders = (apiToken: string) => {
    return {
        Authorization: `Bearer ${apiToken}`,
    }
};

export const getCustomers = async (apiToken: string) => {
    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/customers`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
}

export const getCustomer = async (apiToken: string, id: string) => {
    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/customers/${id}`, {
            headers: createHeaders(apiToken)
        }
    )
}

export const findCustomersLikeName = async (apiToken: string, name: string) => {
    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/customers?name=${name}`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
}

export const saveCustomer = async (
    data: Customer,
    apiToken: string,
) => {
    return await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/customers/${data.id}`, data, {
            headers: createHeaders(apiToken)
        }
    )
}

export const createCustomer = async (
    data: CreatedCustomer,
    apiToken: string,
) => {
    return await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/customers`, data, {
            headers: createHeaders(apiToken)
        }
    )
}

